export default "__VITE_ASSET__qyRYnV2H__"